.tocList {
    list-style-type: none;
    padding-left: 1rem;
    display: flex;
    flex-direction: column;
    margin-left: 2.5rem;

    /* Show border on nested lists whenever they are expanded —
     * either they contain the active item (ancestor chain) or
     * they are the direct child of the active item. */
    &:not(.tocListRoot):has([data-toc-active]),
    li[data-toc-active] > & {
        border-left: 1px solid rgb(224, 228, 237);
        margin-bottom: 1rem;
    }

    &.tocListDraft,
    &.tocListRoot {
        margin-left: 0;
    }

    .tocList .tocList {
        margin-left: 0;
    }

    /* Hide nested lists by default — CSS drives TOC expansion */
    &:not(.tocListRoot) {
        display: none;
    }

    /* Show nested lists that contain the active item (ancestor chain) */
    &:not(.tocListRoot):has([data-toc-active]) {
        display: flex;
        flex-direction: column;
    }

    /* Show direct child list of the active item */
    li[data-toc-active] > & {
        display: flex;
        flex-direction: column;
    }

    /* Separate top-level link from its leading icon/progress.
     * Scoped to top-level rows that actually have a preceding sibling,
     * so icon-less rows stay flush-left. */
    &.tocListRoot > li > .tocItem > :first-child + .tocLink {
        margin-left: 1rem;
    }

    li {
        margin: 0;

        .tocLink {
            color: rgba(0, 0, 0, 0.7);
            line-height: 1.125rem;
            text-decoration: none;
            padding: 0.75rem 0;
            flex: 1;

            &:hover {
                text-decoration: underline;
            }
        }

        /* Active item styling via data attribute (set imperatively) */
        &[data-toc-active] > .tocItem {
            margin: 0 0 0 -1rem;
            padding: 0 1rem 0 calc(1rem - 3px);
            border-left: 3px solid rgb(1, 43, 60);
            background-color: rgb(243, 246, 247);
        }
    }
}

.tocItem {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.infoIcon {
    flex: 1.5rem 0 0;
    height: 1.5rem;
    color: rgb(1, 43, 60);
}

.circularProgress {
    flex: none;
    width: 1.5rem;
    height: 1.5rem;
}
